import { isArray } from 'util';
import { NonProductiveManufacturingOrderCategory } from '../non-productive-manufacturing-order-category';

export class NonProductiveManufacturingOrderCategoryBuilder {
  static fromJson(json) {
    return (json)
      ? new NonProductiveManufacturingOrderCategory(
        json.hash,
        json.name,
        json.value
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(NonProductiveManufacturingOrderCategoryBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/non-productive-manufacturing-order-category.builder.ts